import React from 'react';
import { curry, get } from 'lodash';
import { Query, Mutation } from 'react-apollo';

import caseSpecialInstructionsQuery from './caseSpecialInstructionsQuery';
import updateCaseSpecialInstructionsMutation from './updateCaseSpecialInstructionsMutation';

export const buildMutationChild = curry(
  (WrappedComponent, componentProps, mutate) => {
    const { caseId } = componentProps;

    const setCaseSpecialInstructions = specialInstructions =>
      mutate({ variables: { caseId, specialInstructions } });

    return (
      <WrappedComponent
        {...componentProps}
        setCaseSpecialInstructions={setCaseSpecialInstructions}
      />
    );
  },
);

function buildWrappedComponentWithMutation(WrappedComponent, componentProps) {
  return (
    <Mutation
      key={componentProps.caseId}
      mutation={updateCaseSpecialInstructionsMutation}
    >
      {buildMutationChild(WrappedComponent, componentProps)}
    </Mutation>
  );
}

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, queryProps) => {
    const caseData = get(queryProps, 'data.case', {});

    return buildWrappedComponentWithMutation(WrappedComponent, {
      ...componentProps,
      caseId: caseData.id,
      specialInstructions: caseData.specialInstructions,
    });
  },
);

function buildWrappedComponentWithQuery(WrappedComponent, componentProps) {
  const { caseNumber } = componentProps;

  return (
    <Query
      query={caseSpecialInstructionsQuery}
      skip={!caseNumber}
      variables={{ caseNumber }}
    >
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
}

const withCaseSpecialInstructions = WrappedComponent => componentProps =>
  buildWrappedComponentWithQuery(WrappedComponent, componentProps);

export default withCaseSpecialInstructions;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withCaseSpecialInstructions/index.js